export default __webpack_public_path__ + "static/media/padlock.9f4e6730.png";